import React from 'react';
export function FinalCTA() {
  return <section className="bg-rise-black text-rise-white py-14 md:py-24 px-6 text-center relative overflow-hidden" data-id="element-182">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent to-rise-gold/30" data-id="element-183"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-t from-transparent to-rise-gold/30" data-id="element-184"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-185">
        <h2 className="font-playfair text-[40px] md:text-[48px] mb-6" data-id="element-186">
          Ești gata să ieși din blocaj?
        </h2>
        <p className="font-dm-sans text-[19px] text-rise-white/70 mb-10" data-id="element-187">
          Intră în Programul sau în comunitatea R.I.S.E.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-188">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors w-full sm:w-auto" data-id="element-189">
            Rezervă Sesiunea Cadou
          </a>
          <a href="https://comunitatearise.ro/oferterise" target="_top" className="border border-rise-gold text-rise-gold hover:bg-rise-gold/10 px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors w-full sm:w-auto" data-id="element-190">
            Vezi Ofertele R.I.S.E.
          </a>
        </div>
      </div>
    </section>;
}